import React from "react";

export default function PageTitle({ title, fontProps = 'default', subtitle = null }) {
    // Hide on 25 March 2026 1PM GMT+7
    const isHiddenSubtitle = new Date().getTime() >= new Date('2026-03-25T13:00:00+07:00').getTime();

    return (
        <div className="w-full min-h-24 bg-transparent bg-contain bg-no-repeat bg-top pt-36 md:pt-56">
            <div className="relative">
                <div className="container mx-auto 2xl:px-0 md:px-14 px-8">
                    {fontProps === 'default' ? 
                        <h1 className="md:text-7xl text-2xl jersey25 font-bold italic uppercase text-white">
                            {title}
                        </h1> : <h1 className="md:text-4xl jersey25 font-poppins font-bold italic uppercase text-white">
                            {title}
                        </h1>}
                    {!isHiddenSubtitle && subtitle && <p className="text-white text-sm pt-4">{subtitle}</p>}
                </div>
            </div>
        </div>
    );
}
